<template>
    <div class="WidgetStockAntsDisclaimer">
        <WidgetNavbar style="position: fixed;
                        top: 0;
                        width: 100%; z-index: 5;"></WidgetNavbar>
        <div style="margin-top: 35px; height: 100vh; overflow-y: auto;">
            <DisclaimerComponent></DisclaimerComponent>
        </div>

    </div>
</template>
    
<script>
import WidgetNavbar from "@/components/StockAntsLiteWidgets/Navbar.vue";
import DisclaimerComponent from "@/components/RetailSideCompo/DisclaimerComponent.vue";


export default {
    name: "WidgetStockAntsDisclaimer",

    mixins: [],

    components: {
        WidgetNavbar,
        DisclaimerComponent
    },

    data() {
        return {

        }
    },

    methods: {},

};
</script>
<style scoped lang="scss">
@import "../../css/variable.scss";
@import "../../css/common.scss";
</style>
    